import { VPOReportCompletedActionsAction, VPOReportCompletedActionsTypes } from './actions';

interface VPOReportCompletedActionsState {
  data: any | null;
  loading: boolean;
  error: string | null;
}

const initialState: VPOReportCompletedActionsState = {
  data: null,
  loading: false,
  error: null,
};

export const vpoReportCompletedActions = (
  state = initialState,
  action: VPOReportCompletedActionsAction
): VPOReportCompletedActionsState => {
  switch (action.type) {
    case VPOReportCompletedActionsTypes.FETCH_REQUEST:
      return { ...state, loading: true, error: null };

    case VPOReportCompletedActionsTypes.FETCH_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
        error: null,
      };

    case VPOReportCompletedActionsTypes.FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload.error };

    case VPOReportCompletedActionsTypes.CLEAR_DATA:
      return { ...state, data: null };

    default:
      return state;
  }
};
